import * as yup from "yup"

const schemaValidationSchedule = yup.object().shape({
  // 1
  id: yup.string().required("required-field"),
  deliveryType: yup.string().required("required-field"),
  shippingType: yup
    .array(yup.string())
    .min(1, "you-must-enter-at-least-1-shippingType")
    .required("required-field")
    .typeError("you-must-enter-at-least-one-value"),
  datesToReturn: yup.number().integer().min(0).required("required-field"),
  // 2
  status: yup.boolean(),
  permit_enable_time: yup.boolean(),
  enableTime: yup.object().when("permit_enable_time", ([permit_enable_time]: any) => {
    if (permit_enable_time) {
      return yup.object().shape({ from: yup.string(), to: yup.string() }).required("required-field")
    }
    return yup.mixed().nullable()
  }),
  // 3
  type: yup.string().required("required-field"),
  rules: yup.array().when("type", ([type]: any) => {
    if (type === "rules") {
      return yup
        .array(
          yup.object().shape({
            receptionTime: yup.object().shape({
              from: yup.string().required(),
              to: yup.string().required(),
              daysOfWeek: yup.array(yup.number()),
            }),
            deliveryTime: yup.object().shape({
              offset: yup.object().shape({
                value: yup.number().integer().min(0),
                unit: yup.string().required(),
              }),
              fixedHour: yup.string().required(),
              label: yup.string().required("required-field"),
            }),
          }),
        )
        .min(1, "you-must-enter-at-least-1-rule")
        .required("required-field")
        .typeError("you-must-enter-at-least-one-value")
    }
    return yup.mixed()
  }),
  deliverySlots: yup.array(
    yup.object().shape({
      dayOfWeek: yup.number(),
      from: yup.string(),
      to: yup.string(),
      label: yup.string(),
    }),
  ),
  sourceDefaultSettings: yup.object().shape({
    leadtime: yup.object().shape({
      value: yup.number().integer().min(0).required("required-field"),
      unit: yup.string().required("required-field"),
    }),
    crossdock: yup.object().shape({
      value: yup.number().integer().min(0).required("required-field"),
      unit: yup.string().required("required-field"),
    }),
    workingTime: yup.object().shape({
      from: yup.string().required("required-field"),
      to: yup.string().required("required-field"),
    }),
    workingSessions: yup
      .array(
        yup.object().shape({
          // capacity: yup.number().integer().min(0).required("required-field"),
          productType: yup.string().required("required-field"),
          from: yup.string().required("required-field"),
          to: yup.string().required("required-field"),
          enable_locktime: yup.boolean(),
          lockTime: yup.object().shape({
            from: yup.mixed(),
            to: yup.mixed(),
          }),
        }),
      )
      .min(1, "you-must-enter-at-least-1-source")
      .required("required-field")
      .typeError("you-must-enter-at-least-one-value"),
  }),
  productDefaultSettings: yup.object().shape({
    leadtime: yup.object().shape({
      value: yup.number().integer().min(0).required("required-field"),
      unit: yup.string().required("required-field"),
    }),
    volume: yup.number().integer().min(0).required("required-field"),
    cost: yup.number().integer().min(0).required("required-field"),
  }),
})

export default schemaValidationSchedule

export const schemaValidationQuerySchedule = yup.object().shape({
  channel: yup.string().required("required-field"),
  shippingType: yup
    .array(yup.string())
    .min(1, "you-must-enter-at-least-1-shippingType")
    .required("required-field")
    .typeError("you-must-enter-at-least-one-value"),
  storePickupId: yup.string(),
  enableSimulatedDate: yup.boolean(),
  simulatedDate: yup.string(),
  shippingAddress: yup.object().shape({
    country: yup.object().shape({ id: yup.string().required("required-field") }),
    region: yup.object().shape({ id: yup.string().required("required-field") }),
    location: yup.object().shape({}),
    address: yup.string(),
  }),
  contact: yup.object().shape({
    name: yup.string(),
    email: yup.string().email(),
    phone: yup.string(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required("required-field"),
        sku: yup.string().required("required-field"),
        quantity: yup.number().positive().integer().required("required-field"),
      }),
    )
    .min(1, "you-must-enter-at-least-one-item")
    .required("required-field")
    .typeError("you-must-enter-at-least-one-value"),
})
